<script setup lang="ts">
import { useMutation } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';
import type { AxiosError } from 'axios';
import { ServiceCompanyAuditUsersApi, type ServiceCompanyAuditUser } from '@/api/service-company-audit-users';

const { t } = useI18n();

interface Props {
  auditUser: ServiceCompanyAuditUser;
  serviceCompanyId: number;
}

interface Emits {
  (e: 'success'): void;
  (e: 'cancel'): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const { mutate, isError } = useMutation<unknown, AxiosError>(
  {
    mutationFn: () => ServiceCompanyAuditUsersApi.destroy(props.auditUser.id),
    onSuccess: () => {
      emit('success');
    },
  },
);
</script>

<template>
  <v-card>
    <v-card-title class="mt-2 d-flex font-weight-bold">
      Eliminar Usuario
    </v-card-title>
    <v-card-text>
      ¿Está seguro de que desea eliminar al usuario {{ auditUser.email }}?
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="isError"
        @click="emit('cancel')"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="error"
        :loading="isError"
        @click="mutate"
      >
        Eliminar
      </v-btn>
    </v-card-actions>
    <v-alert
      v-if="isError"
      type="error"
      variant="tonal"
      class="mt-4"
    >
      {{ t('userSession.defaultError') }}
    </v-alert>
  </v-card>
</template>
